var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPressureTomorrowio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    className: "weather-filter-parameter__icon--Huru",
    fill: "current",
    stroke: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19,6.6429c-0.5917,0-1.0714-0.4797-1.0714-1.0714 C17.9286,4.9797,18.4083,4.5,19,4.5s1.0714,0.4797,1.0714,1.0714C20.0714,6.1632,19.5917,6.6429,19,6.6429z M19,12.3571 c-0.9862,0-1.7857-0.7995-1.7857-1.7857S18.0138,8.7857,19,8.7857s1.7857,0.7995,1.7857,1.7857S19.9862,12.3571,19,12.3571z  M19,19.5c-1.3807,0-2.5-1.1193-2.5-2.5s1.1193-2.5,2.5-2.5s2.5,1.1193,2.5,2.5S20.3807,19.5,19,19.5z M12,6.6429 c-0.5917,0-1.0714-0.4797-1.0714-1.0714C10.9286,4.9797,11.4083,4.5,12,4.5s1.0714,0.4797,1.0714,1.0714 C13.0714,6.1632,12.5917,6.6429,12,6.6429z M12,12.3571c-0.9862,0-1.7857-0.7995-1.7857-1.7857S11.0138,8.7857,12,8.7857 s1.7857,0.7995,1.7857,1.7857S12.9862,12.3571,12,12.3571z M12,19.5c-1.3807,0-2.5-1.1193-2.5-2.5s1.1193-2.5,2.5-2.5 s2.5,1.1193,2.5,2.5S13.3807,19.5,12,19.5z M5,6.6429c-0.5917,0-1.0714-0.4797-1.0714-1.0714C3.9286,4.9797,4.4083,4.5,5,4.5 s1.0714,0.4797,1.0714,1.0714C6.0714,6.1632,5.5917,6.6429,5,6.6429z M5,12.3571c-0.9862,0-1.7857-0.7995-1.7857-1.7857 S4.0138,8.7857,5,8.7857s1.7857,0.7995,1.7857,1.7857S5.9862,12.3571,5,12.3571z M5,19.5c-1.3807,0-2.5-1.1193-2.5-2.5 s1.1193-2.5,2.5-2.5s2.5,1.1193,2.5,2.5S6.3807,19.5,5,19.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressureTomorrowio);
export default __webpack_public_path__ + "static/media/pressure-tomorrowio.9d111c71cb189e210e4d1bfe57d2208c.svg";
export { ForwardRef as ReactComponent };